import httpClient from './httpClient';
import { ENDPOINT_API } from '../../enums/endpoint';

// Re-sync allocation
export const getReSyncAllocation = () => httpClient.get(`${ENDPOINT_API.HOOKS}/check-allocation-status`);
export const postReSyncAllocation = () => httpClient.post(`${ENDPOINT_API.HOOKS}/worker-stock-synced`);
